import React from 'react';
import { connect } from 'react-redux';
import ReactTimeout from 'react-timeout';
import { logoutPrepare } from '../actions/login';
import { contentChange } from '../actions/content';
import { submitOrder } from '../actions';
import { resetBundle, resetOptions, resetSerial, resetPayment, resetOrder, resetCheckout,resetPrivacy, resetSepa, resetFinish, resetTeacher, resetTeacherOverlay } from '../actions/status';
import { resetPayever } from '../actions/payever';
import moment from 'moment';
import 'moment/locale/de';
import SimpleButton from '../components/atoms/SimpleButton';
import Headline from '../components/atoms/Headline';
import FinishOverview from '../components/organisms/FinishOverview';

var AppConfig = require('../config.json');

class FinishedView extends React.Component {
  constructor(props) {
    super(props);
    this.retrySubmitOrder = this.retrySubmitOrder.bind(this);
    this.toggleStatus = this.toggleStatus.bind(this);
    this.logoutClick = this.logoutClick.bind(this);
    this.makeVisible = this.makeVisible.bind(this);
    this.findConfiguration = this.findConfiguration.bind(this);
    this.submitOrderAndFinish = this.submitOrderAndFinish.bind(this);
    this.resetOrderSpecs = this.resetOrderSpecs.bind(this);
    this.state = {
      submitting: false,
      status: '',
      hidden: false
    };
    this.resetOnce = false;
  }

  findConfiguration(bundle) {
    return this.props.status.bundle.id === bundle.id;
  }
  logoutClick() {
    this.props.dispatch(logoutPrepare());
    this.props.dispatch(contentChange('logout'));
  }

  submitOrderAndFinish() {
    if (this.props.status.submit.status !== 'success') {
      const bundle = this.props.status.project.data.bundles.find(
        this.findConfiguration
      );
      var street = this.props.status.order.form.strasse;
      if(this.props.status.order.form.hausnummer!==street) {
        street = street.concat(" ", this.props.status.order.form.hausnummer);
      }
      var form = {
        projectsId: this.props.status.project.id,
        bundlesId: this.props.status.bundle.id,
        articles: this.props.status.options.articles,
        paymentType: this.props.status.payment.type,
        paymentRuntime: parseInt(this.props.status.payment.paymentRuntime, 10),
        paymentAmount: this.props.status.payment.paymentPrice,
        anrede: this.props.status.order.form.anrede,
        vorname: this.props.status.order.form.vorname,
        nachname: this.props.status.order.form.nachname,
        
        strasse: street,
        plz: parseInt(this.props.status.order.form.plz, 10),
        ort: this.props.status.order.form.ort,
        land: this.props.status.order.form.land,
        email: this.props.status.order.form.email,
        telefon: this.props.status.order.form.telefon,
        fax: this.props.status.order.form.fax,
        kontoinhaber: this.props.status.order.form.kontoinhaber,
        bank: this.props.status.order.form.bank,
        iban: this.props.status.order.form.iban,
        bic: this.props.status.order.form.bic,
        support: this.props.status.order.form.support,
        customdata: this.props.status.order.form.customdata,
        upload: this.props.status.order.form.upload,
        sponsoring: bundle.sponsoring.active,
        isDep: this.props.status.project.isDep ? 1 : 0,
        payever: {}
      };
      if(AppConfig.inputoptions.birthdatecustomer) {
        form.geburtstag = moment
          .utc(this.props.status.order.form.geburtstag, AppConfig.dateFormat)
          .unix();
      }
      if(!this.props.status.project.teachers) {
        form.namekind = this.props.status.order.form.nachnamekind;
        form.vornamekind = this.props.status.order.form.vornamekind;
        if(this.props.status.order.form.geburtstagkind!=="") {
          form.geburtstagkind = moment
          .utc(this.props.status.order.form.geburtstagkind, AppConfig.dateFormat)
          .unix();
        } else {
          form.geburtstagkind = "";
        }
      } else {
        form.schoolname = this.props.status.order.form.schoolname;
      }

      var checkboxes = [];
      if(this.props.status.checkout.checkbox) {
        checkboxes.push("checkout");
      }
      if(this.props.status.teacher.checkbox) {
        checkboxes.push("checkout");
      }
      if(this.props.status.privacy.checkbox) {
        checkboxes.push("privacy");
      }
      if(this.props.status.sepa.checkbox) {
        checkboxes.push("sepa");
      }
      if(this.props.status.project.isDep) {
        checkboxes = checkboxes.concat(this.props.status.checkoutDep.checkboxes);
      }
      form.checkboxes = checkboxes;
      
      if(this.props.status.requestSerial.isset && this.props.status.requestSerial.sn!=="") {
        form.seriennummer =this.props.status.requestSerial.sn;
      }
      if(this.props.status.payment.type==='sf' && this.props.payever.id!==0) {
        form.land = "DE";
        form.payever = Object.assign({
          internalId: this.props.payever.id,
          orderId: this.props.payever.orderId
        }, this.props.payever.details);

      }
     this.props.submitOrder(form);
    }
    if (this.props.status.submit.status === 'success' && this.state.status!=='success') {
      this.setState({ status: this.props.status.submit.status });
    }
  }

  toggleStatus() {
    this.setState({ status: this.props.status.submit.status, hidden: false });
  }
  makeVisible() {
    this.setState({ status: 'success', hidden: false });
  }

  componentDidMount() {
    this.props.setTimeout(this.submitOrderAndFinish, 500);
  }

  componentDidUpdate(prevProps, prevState) {
    
      if(this.state.status==='success' && prevState.status!=='success') {
        this.props.setTimeout(this.resetOrderSpecs, 1000);
        this.props.setTimeout(this.makeVisible, 200);

      } 
  }
  componentWillUpdate(nextProps, nextState) {
    if(!this.state.submitting) {
      if (
        nextProps.status.submit.status !== this.state.status &&
        !this.state.hidden
      ) {
        this.setState({ hidden: true });
      }
      if (
        nextProps.status.submit.status !== this.state.status &&
        (this.state.status === '' || this.state.status === 'error')
      ) {
        this.props.setTimeout(this.toggleStatus, 500);
        if(!this.resetOnce) {
          this.resetOnce = true;
        }
      }
    } else {
      if (this.state.submitting) {
        this.setState({ submitting: false });
      }
    }
  }
  printOrder() {
    window.print();
  }
  retrySubmitOrder() {
    if (this.state.submitting) {
      return;
    }
    this.setState({ submitting: true });
    this.props.setTimeout(this.submitOrderAndFinish, 200);
  }

  setHidden() {
    this.setState({ hidden: true });
  }


  resetOrderSpecs() {
    this.props.dispatch(resetBundle());
    this.props.dispatch(resetOptions());
    this.props.dispatch(resetSerial());
    this.props.dispatch(resetPayment());
    this.props.dispatch(resetOrder());
    this.props.dispatch(resetCheckout());
    this.props.dispatch(resetPrivacy());
    this.props.dispatch(resetSepa());
    this.props.dispatch(resetFinish());
    this.props.dispatch(resetPayever());
    this.props.dispatch(resetTeacher());
    this.props.dispatch(resetTeacherOverlay());
  }

  render() {
    return (
      <div
        className={`contentview finished${this.state.hidden
          ? ' hidden'
          : ''}${this.state.status !== '' ? ' reveal' : ''}`}
      >
        {this.state.status === 'success' ? (
          <div className="process success">
            <div className="thankyoucontent">
              <h2>Vielen Dank für Ihre Bestellung.</h2>
              {!this.props.status.project.isDep &&
                <p>
                  Wir haben diese soeben erhalten und werden Sie umgehend kontaktieren, um die weiteren Schritte zu besprechen.<br />Viele Grüsse, Ihr schoolTab Team. 
                </p>
              }
              
              <div className="logoutbtn">
                <SimpleButton
                  children="Bestellung ausdrucken"
                  onClick={this.printOrder}
                />
                <SimpleButton
                  children="Jetzt ausloggen"
                  onClick={this.logoutClick}
                />
              </div>
            </div>
            <div className="thankyouprint">
              <FinishOverview />
            </div>
          </div>
        ) : this.state.status === 'error' ? (
          <div className="process error">
            <h2>Ein Fehler ist aufgetreten.</h2>
            {this.props.status.submit.msg!=="" &&
              <p>Fehlerbeschreibung: {this.props.status.submit.msg}</p>
            }
            <p>
              Wir konnten Ihre Bestellung im Moment leider nicht übermitteln.<br />
              Bitte versuchen Sie es erneut oder wenden Sie sich an das schoolTab Team.
            </p>
            <div className="retrybtn">
              <SimpleButton
                children={
                  this.state.submitting ? 'Sende Daten…' : 'Erneut versuchen'
                }
                onClick={this.retrySubmitOrder}
              />
            </div>
          </div>
        ) : this.state.status === '' ? (
          <div className="process submitting">
            <Headline typeOf="h2" alignment="center">
              Verarbeite Bestellung
            </Headline>
            <div className="spinner">
              <div className="mnml-spinner" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    status: state.status,
    payever: state.payever
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatch: dispatch,
    submitOrder: orderform => {
      submitOrder(orderform)(dispatch);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(
  ReactTimeout(FinishedView)
);



// WEBPACK FOOTER //
// ./src/views/FinishedView.js